import { BehaviorSubject } from "rxjs";

export const showSavingsIcon$ = new BehaviorSubject(false);
